import { PointerComponent } from './components/pointer/pointer.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CenterComponent } from './components/center/center.component';
import { FrameComponent } from './components/frame/frame.component';
import { NavbarComponent } from './components/navbar/navbar.component';
import { WelcomePageComponent } from './components/welcome-page/welcome-page.component';
import {RouterModule} from '@angular/router';
import { FloorComponent } from './components/floor/floor.component';

const sharedComponents = [
    PointerComponent,
    CenterComponent,
    FrameComponent,
    NavbarComponent,
    FloorComponent,
];

@NgModule({
    declarations: [ ... sharedComponents, WelcomePageComponent],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule
    ],
    exports: [...sharedComponents]
})
export class SharedModule { }
